/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import SVG from 'react-inlinesvg';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_helpers';
import useFeatureFlag from '../../../../../app/hooks/useFeatureFlag/index.js';
import { FEATURE_FLAGS } from '../../../../../app/constants/FeatureFlag.js';

// Grupos "Pagamentos (legado)" (JusBill) e "Pagamentos (novo)" (JusSub) do menu lateral.
export function PaymentsMenuList() {
  const location = useLocation();

  // Não usa o checkIsActive de _helpers: ele faz indexOf (substring solto),
  // então "/plans" "acha" "/payments/plans" e "/coupons" "acha"
  // "/payments/coupons" em qualquer posição da string. Aqui exige fronteira
  // de segmento de verdade (match exato ou prefixo seguido de "/").
  const isRouteActive = (url) =>
    location.pathname === url || location.pathname.startsWith(`${url}/`);
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return isRouteActive(url)
      ? ` ${!hasSubmenu &&
          'menu-item-active'} menu-item-open menu-item-not-hightlighted`
      : '';
  };

  const newArchFeatureAvailable = useFeatureFlag(
    FEATURE_FLAGS.KILL_SWITCH.ADMIN_PAYMENTS_ARCH_V2,
  );

  const jusSubEnabled =
    newArchFeatureAvailable?.flagResolved &&
    newArchFeatureAvailable?.isFeatureFlagEnable;

  const jusBillActive = [
    '/plans',
    '/subscription_migration',
    '/coupons',
    '/plan_groups',
  ].some(isRouteActive);
  const jusBillOpen = !jusSubEnabled || jusBillActive;

  return (
    <>
      {jusSubEnabled && (
        <li
          className="menu-item menu-item-submenu menu-item-open"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <a href="#" className="menu-link menu-toggle">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl('/media/svg/icons/Shopping/Credit-card.svg')}
              />
            </span>
            <span className="menu-text">Pagamentos (JusSub)</span>
            <i className="menu-arrow" />
          </a>
          <div className="menu-submenu">
            <ul className="menu-subnav">
              <li
                className={`menu-item ${getMenuItemActive(
                  '/payments/coupons',
                  false,
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/payments/coupons">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl('/media/svg/icons/Sidebar/Cupons.svg')}
                    />
                  </span>
                  <span className="menu-text">Cupons</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  '/payments/items',
                  false,
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/payments/items">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        '/media/svg/icons/Sidebar/Produtos.svg',
                      )}
                    />
                  </span>
                  <span className="menu-text">Produtos</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  '/payments/plans',
                  false,
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/payments/plans">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl('/media/svg/icons/Sidebar/Plans.svg')}
                    />
                  </span>
                  <span className="menu-text">Planos</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  '/payments/offers',
                  false,
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/payments/offers">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl('/media/svg/icons/Shopping/Sale1.svg')}
                    />
                  </span>
                  <span className="menu-text">Ofertas</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
      )}

      <li
        className={`menu-item menu-item-submenu ${
          jusBillOpen ? 'menu-item-open' : ''
        }`}
        aria-haspopup="true"
        data-menu-toggle="hover"
      >
        <a href="#" className="menu-link menu-toggle">
          <span className="svg-icon menu-icon">
            <SVG src={toAbsoluteUrl('/media/svg/icons/Shopping/Wallet.svg')} />
          </span>
          <span className="menu-text">Pagamentos (legado)</span>
          <i className="menu-arrow" />
        </a>
        <div className="menu-submenu">
          <ul className="menu-subnav">
            <li
              className={`menu-item ${getMenuItemActive('/plans', false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/plans">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl('/media/svg/icons/Sidebar/Plans.svg')}
                  />
                </span>
                <span className="menu-text">Planos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                '/subscription_migration',
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/subscription_migration">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      '/media/svg/icons/Sidebar/Migrations.svg',
                    )}
                  />
                </span>
                <span className="menu-text">Migrações</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive('/cupons', false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/coupons">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl('/media/svg/icons/Sidebar/Cupons.svg')}
                  />
                </span>
                <span className="menu-text">Cupom</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                '/plan_groups',
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="plan_groups">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      '/media/svg/icons/Sidebar/PlanGroup.svg',
                    )}
                  />
                </span>
                <span className="menu-text">Grupo de Planos</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </li>
    </>
  );
}
